import React from 'react';

// hooks
import { useFeatureFlags } from '../context/FeatureFlagContext';

export function withFeatureFlags<P extends object>(
    Component: React.ComponentType<P>,
) {
    return (props: P) => {
        const featureFlags = useFeatureFlags();

        return <Component {...props} featureFlags={featureFlags} />;
    };
}
